function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import React, { createContext, useEffect, useMemo, useState, useReducer, useRef } from 'react';
import { nanoid, makeGridMap, makeGridInfo } from '../utils';
import { gridMap as defaultGridMap, includeData as defaultIncludeData, dataSizeJson } from '../settings/default';
import lodash from 'lodash';
export var ResponsiveContext = /*#__PURE__*/createContext({
  state: null,
  onSelect: null,
  pageData: [],
  selectComSize: [0, 0],
  onHandleSetSelectComSize: null,
  onHandleTrigger: null,
  onHandleChangeItemSize: null,
  onHandleSetGridGroup: null,
  comDragingRef: {
    current: false
  }
});
var splitGridHorizontal = function splitGridHorizontal(state, com_id) {
  var seletid = com_id;
  var dataBase = state.dataBase;
  var selectcom = dataBase[seletid];
  var arr = state.comps.map(function (i) {
    return state.dataBase[i];
  });
  var ogridMap = makeGridMap(arr);
  var targetGrid = selectcom.grid.split('/').map(Number);
  var gridSizeMap = state.gridSizeMap;
  // 所占单元格数为奇数，先把所在格中间行扩充一列
  var midNum = Math.ceil((targetGrid[3] - targetGrid[1]) / 2) + targetGrid[1] - 1;
  if ((targetGrid[3] - targetGrid[1]) % 2 == 1) {
    var _iterator = _createForOfIteratorHelper(ogridMap),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var i = _step.value;
        i.splice(midNum, 0, i[midNum - 1]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    var mapx = gridSizeMap.x;
    mapx.splice(midNum - 1, 1, mapx[midNum - 1] / 2, mapx[midNum - 1] / 2);
  }
  var newId = nanoid();
  var width = ogridMap[0].length;
  var height = ogridMap.length;
  for (var y = 0; y < height; y++) {
    for (var x = 0; x < width; x++) {
      if (ogridMap[y][x] == seletid && x >= midNum) {
        ogridMap[y][x] = newId;
      }
    }
  }
  var gridInfo = makeGridInfo(ogridMap, gridSizeMap);
  state.dataBase[newId] = {
    com_id: newId,
    grid: ''
  };
  state.comps.push(newId);
  for (var _i in gridInfo) {
    state.dataBase[_i].grid = gridInfo[_i].join('/');
  }
  return _objectSpread({}, state);
};
var splitGridVertical = function splitGridVertical(state, com_id) {
  var seletid = com_id;
  var dataBase = state.dataBase;
  var selectcom = dataBase[seletid];
  var arr = state.comps.map(function (i) {
    return state.dataBase[i];
  });
  var ogridMap = makeGridMap(arr);
  var targetGrid = selectcom.grid.split('/').map(Number);
  var gridSizeMap = state.gridSizeMap;
  // 所占单元格数为奇数，先把所在格中间行扩充一行
  var midNum = Math.ceil((targetGrid[2] - targetGrid[0]) / 2) + targetGrid[0] - 1;
  if ((targetGrid[2] - targetGrid[0]) % 2 == 1) {
    ogridMap.splice(midNum, 0, _toConsumableArray(ogridMap[midNum - 1]));
    var mapy = gridSizeMap.y;
    mapy.splice(midNum - 1, 1, mapy[midNum - 1] / 2, mapy[midNum - 1] / 2);
  }
  var newId = nanoid();
  var width = ogridMap[0].length;
  var height = ogridMap.length;
  for (var y = 0; y < height; y++) {
    for (var x = 0; x < width; x++) {
      if (ogridMap[y][x] == seletid && y >= midNum) {
        ogridMap[y][x] = newId;
      }
    }
  }
  var gridInfo = makeGridInfo(ogridMap, gridSizeMap);
  state.dataBase[newId] = {
    com_id: newId,
    grid: ''
  };
  state.comps.push(newId);
  for (var i in gridInfo) {
    state.dataBase[i].grid = gridInfo[i].join('/');
  }
  return _objectSpread({}, state);
};
var deleteItem = function deleteItem(state, com_id) {
  if (state.comps.length == 1) {
    state.gridSizeMap = {
      x: [],
      y: []
    };
  } else {
    var arr = state.comps.map(function (i) {
      return state.dataBase[i];
    });
    var ogridMap = makeGridMap(arr);
    var targetGrid = state.dataBase[com_id].grid.split('/').map(Number);
    // 先左后右，再上最后下
    var canDel = false;
    var y = targetGrid[0] - 1;
    var x = targetGrid[1] - 1;
    var ye = targetGrid[2] - 1;
    var xe = targetGrid[3] - 1;
    if (x > 0 && !canDel) {
      var _ogridMap$y, _ogridMap, _ogridMap2, _ogridMap$ye;
      // ←
      if (((_ogridMap$y = ogridMap[y]) === null || _ogridMap$y === void 0 ? void 0 : _ogridMap$y[x - 1]) != ((_ogridMap = ogridMap[y - 1]) === null || _ogridMap === void 0 ? void 0 : _ogridMap[x - 1]) && ((_ogridMap2 = ogridMap[ye - 1]) === null || _ogridMap2 === void 0 ? void 0 : _ogridMap2[x - 1]) != ((_ogridMap$ye = ogridMap[ye]) === null || _ogridMap$ye === void 0 ? void 0 : _ogridMap$ye[x - 1])) {
        canDel = true;
        for (var xi = x; xi < xe; xi++) {
          for (var yi = y; yi < ye; yi++) {
            ogridMap[yi][xi] = ogridMap[yi][x - 1];
          }
        }
      }
    }
    if (xe < ogridMap[0].length && !canDel) {
      var _ogridMap$y2, _ogridMap3, _ogridMap$ye2, _ogridMap4;
      // →
      if (((_ogridMap$y2 = ogridMap[y]) === null || _ogridMap$y2 === void 0 ? void 0 : _ogridMap$y2[xe]) != ((_ogridMap3 = ogridMap[y - 1]) === null || _ogridMap3 === void 0 ? void 0 : _ogridMap3[xe]) && ((_ogridMap$ye2 = ogridMap[ye]) === null || _ogridMap$ye2 === void 0 ? void 0 : _ogridMap$ye2[xe]) != ((_ogridMap4 = ogridMap[ye - 1]) === null || _ogridMap4 === void 0 ? void 0 : _ogridMap4[xe])) {
        canDel = true;
        for (var _xi = x; _xi < xe; _xi++) {
          for (var _yi = y; _yi < ye; _yi++) {
            ogridMap[_yi][_xi] = ogridMap[_yi][xe];
          }
        }
      }
    }
    if (y > 0 && !canDel) {
      var _ogridMap5, _ogridMap6, _ogridMap7, _ogridMap8;
      // ↑
      if (((_ogridMap5 = ogridMap[y - 1]) === null || _ogridMap5 === void 0 ? void 0 : _ogridMap5[x]) != ((_ogridMap6 = ogridMap[y - 1]) === null || _ogridMap6 === void 0 ? void 0 : _ogridMap6[x - 1]) && ((_ogridMap7 = ogridMap[y - 1]) === null || _ogridMap7 === void 0 ? void 0 : _ogridMap7[xe - 1]) != ((_ogridMap8 = ogridMap[y - 1]) === null || _ogridMap8 === void 0 ? void 0 : _ogridMap8[xe])) {
        canDel = true;
        for (var _xi2 = x; _xi2 < xe; _xi2++) {
          for (var _yi2 = y; _yi2 < ye; _yi2++) {
            ogridMap[_yi2][_xi2] = ogridMap[y - 1][_xi2];
          }
        }
      }
    }
    if (y < ogridMap.length && !canDel) {
      var _ogridMap$ye3, _ogridMap$ye4, _ogridMap$ye5, _ogridMap$ye6;
      // ↓
      if (((_ogridMap$ye3 = ogridMap[ye]) === null || _ogridMap$ye3 === void 0 ? void 0 : _ogridMap$ye3[x - 1]) != ((_ogridMap$ye4 = ogridMap[ye]) === null || _ogridMap$ye4 === void 0 ? void 0 : _ogridMap$ye4[x]) && ((_ogridMap$ye5 = ogridMap[ye]) === null || _ogridMap$ye5 === void 0 ? void 0 : _ogridMap$ye5[xe - 1]) != ((_ogridMap$ye6 = ogridMap[ye]) === null || _ogridMap$ye6 === void 0 ? void 0 : _ogridMap$ye6[xe])) {
        canDel = true;
        for (var _xi3 = x; _xi3 < xe; _xi3++) {
          for (var _yi3 = y; _yi3 < ye; _yi3++) {
            ogridMap[_yi3][_xi3] = ogridMap[ye][_xi3];
          }
        }
      }
    }
    var gridInfo = makeGridInfo(ogridMap, state.gridSizeMap);
    for (var i in gridInfo) {
      state.dataBase[i].grid = gridInfo[i].join('/');
    }
  }
  state.comps = state.comps.filter(function (i) {
    return i != com_id;
  });
  delete state.dataBase[com_id];
  if (state.select == com_id) {
    state.select = null;
  }
  return _objectSpread({}, state);
};
var ResponsiveContextProvider = function ResponsiveContextProvider(props) {
  var reducer = function reducer(state, action) {
    switch (action.type) {
      case 'onSelect':
        state.select = action.select;
        return _objectSpread({}, state);
      case 'horizontal':
        return splitGridHorizontal(lodash.cloneDeep(state), action.select);
      case 'vertical':
        return splitGridVertical(lodash.cloneDeep(state), action.select);
      case 'onDelete':
        return deleteItem(lodash.cloneDeep(state), action.select);
      case 'onChangeItemSize':
        state.gridSizeMap = action.gridSizeMap;
        return _objectSpread({}, state);
      case 'onChangeItems':
        state = action.state;
        return state;
      default:
        return state;
    }
  };
  var reducerInit = function reducerInit(state) {
    var _iterator2 = _createForOfIteratorHelper(defaultIncludeData),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var i = _step2.value;
        var newId = nanoid();
        state.comps.push(newId);
        state.dataBase[newId] = {
          com_id: newId,
          grid: i.grid
        };
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    state.gridSizeMap = defaultGridMap;
    return state;
  };
  var _useReducer = useReducer(reducer, {
      gridSizeMap: {
        x: [],
        y: []
      },
      select: null,
      comps: [],
      dataBase: {}
    }),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  var _useState = useState([0, 0]),
    _useState2 = _slicedToArray(_useState, 2),
    selectComSize = _useState2[0],
    setSelectComSize = _useState2[1];
  var onHandleSetSelectComSize = function onHandleSetSelectComSize() {
    if (state.select && state.select != 'container') {
      var selectdom = document.querySelector("[data-com_id='".concat(state.select, "']"));
      var rect = selectdom.getBoundingClientRect();
      setSelectComSize([Math.round(rect.width), Math.round(rect.height)]);
    } else {
      setSelectComSize([0, 0]);
    }
  };
  useEffect(function () {
    onHandleSetSelectComSize();
  }, [state.select, state.gridSizeMap]);
  var onSelect = function onSelect(com) {
    dispatch({
      type: 'onSelect',
      select: com
    });
  };
  var onHandleChangeItemSize = function onHandleChangeItemSize(gridSizeMap) {
    dispatch({
      type: 'onChangeItemSize',
      gridSizeMap: gridSizeMap
    });
  };
  var onHandleTrigger = function onHandleTrigger(name, com) {
    dispatch({
      type: name,
      select: com
    });
  };
  var onHandleSetGridGroup = function onHandleSetGridGroup(type) {
    var target = dataSizeJson[type];
    var state = {
      gridSizeMap: {
        x: [],
        y: []
      },
      select: null,
      comps: [],
      dataBase: {}
    };
    state.gridSizeMap = target.map;
    var _iterator3 = _createForOfIteratorHelper(target.data),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var i = _step3.value;
        var newId = nanoid();
        state.dataBase[newId] = {
          com_id: newId,
          grid: i.grid
        };
        state.comps.push(newId);
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
    dispatch({
      type: 'onChangeItems',
      state: state
    });
  };
  var pageData = useMemo(function () {
    return state.comps.map(function (i) {
      return state.dataBase[i];
    });
  }, [state.dataBase, state.comps]);
  var comDragingRef = useRef(false);
  return /*#__PURE__*/React.createElement(ResponsiveContext.Provider, {
    value: {
      state: state,
      onSelect: onSelect,
      pageData: pageData,
      selectComSize: selectComSize,
      onHandleSetSelectComSize: onHandleSetSelectComSize,
      onHandleTrigger: onHandleTrigger,
      onHandleChangeItemSize: onHandleChangeItemSize,
      onHandleSetGridGroup: onHandleSetGridGroup,
      comDragingRef: comDragingRef
    }
  }, props.children);
};
export default ResponsiveContextProvider;